import { Respuesta } from './../entities/respuesta.entity';
import { Contrato } from './../entities/contrato.entity';
import { SessionService } from './../services/session.service';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

export interface FormModel {
  captcha?: string;
}

@Component({
  selector: 'app-lecturacontador',
  styles: [`
    .error { color: crimson; }
    .success { color: green; }
  `],
  templateUrl: './lecturacontador.component.html'
})
export class LecturaContadorComponent implements OnInit {
  public date: Date;
  public name: string;
  public dni: string;
  public email: string;
  public telefono: string;
  public num_contrato: number;
  public lectura: string;
  public lecturaNumber: number;
  public direccionSuministro: string;
  public contratoSeleccionado: Contrato;
  public files: any[] = [];
  public images = [];
  public politicas: boolean;
  public condicionesEnvio: string;

  public dateInputError = false;
  public lecturaInputError = false;
  public politicasError = false;

  public resultado: Respuesta;
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  public formModel: FormModel = {};
  public keyCapchasite: string;
  public captchaError: boolean;
  public empresa: string;

  constructor(private userService: UserService, private sessionService: SessionService, private router: Router) { }

  ngOnInit() {
    this.empresa = environment.site;
    if (this.sessionService.isAuthenticated) {
      this.name = this.sessionService.nombre;
      this.dni = this.sessionService.login;
      this.email = this.sessionService.email;
      this.telefono = this.sessionService.telefono;
      this.num_contrato = this.sessionService.contratoSelected.Codigo;
      this.direccionSuministro = this.sessionService.contratoSelected.InmuebleBO.Direccion;
      this.keyCapchasite = environment.capchasiteKey;
      this.condicionesEnvio = this.sessionService.datosExplotacion.PoliticaEnvio;
    } else {
      this.router.navigate(['/']);
    }
  }

  public enviar(event): void {
    this.date = event.nombre;
  }

  public recibirContrato(event): void {
    this.num_contrato = event.contratoSeleccionado.Codigo;
    this.direccionSuministro = event.contratoSeleccionado.InmuebleBO.Direccion;
    this.clearInputErrors();
  }

  public actualizar() {
    this.cambiar();
    this.clearInputErrors();
    const formData: FormData = new FormData();
    if (this.sessionService.files.length > 0) {
      for (let j = 0; j < this.sessionService.files.length; j++) {
        formData.append('file[]', this.sessionService.files[j], this.sessionService.files[j].name);
      }
    }
    this.formModel.captcha = this.formModel.captcha === undefined ? null : this.formModel.captcha;
    if (this.lectura !== undefined) {
      this.lectura = this.lectura.toString() === '' ? undefined : this.lectura;
    }
    this.date = this.date === null ? undefined : this.date;
    if (!isNaN(this.lecturaNumber) && this.date !== undefined && this.formModel.captcha !== null && this.politicas === true) {
      formData.append('Nombre', this.name);
      formData.append('Nif', this.dni);
      formData.append('EMail', this.email);
      formData.append('Telefono', this.telefono);
      formData.append('Contrato', this.sessionService.contratoSelected.Codigo.toString());
      formData.append('Direccion', this.sessionService.contratoSelected.InmuebleBO.Direccion);
      formData.append('LecturaContador', this.lectura.toString());
      formData.append('FechaLectura', this.date.toString());
      formData.append('ModoTest', this.sessionService.usuario.ModoTest === undefined ? false.toString() :
        this.sessionService.usuario.ModoTest.toString());
      formData.append('gRecaptchaResponse', this.formModel.captcha);
      if(document.getElementById('top') !== null)    
      document.getElementById('top').scrollIntoView();
      
      this.userService.upload(this.sessionService.explotacion, formData).subscribe(
        response => this.uploadOnSuccess(response),
        response => this.uploadOnError(response)
      );
    } else {
      this.lecturaInputError = isNaN(this.lecturaNumber);
      this.dateInputError = this.date === undefined ? true : false;
      this.politicasError = !this.politicas;
      this.captchaError = this.formModel.captcha === null ? true : false;
    }
  }

  refreshImages(event) {
    this.files = event.ficheros;
  }

  public uploadOnSuccess(response) {
    if (response.StatusCode === '400') {
      this.messageCabecera = 'Error en el envío de la lectura';
      this.messageComplet = 'La lectura ha de ser un número entero';
      this.typeException = 1;
    } else {
      this.messageCabecera = 'Lectura enviada correctamente';
      this.messageComplet = 'La lectura se ha enviado correctamente';
      this.typeException = 2;
    }
  }

  public uploadOnError(response) {
    this.resultado = response;
    this.formModel.captcha = null;
    this.messageCabecera = 'Error en el envío de la lectura';
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.messageComplet = 'Se ha producido en el envío';
      this.typeException = 1;
    }
  }

  public clearInputErrors() {
    this.lecturaInputError = false;
    this.dateInputError = false;
    this.captchaError = false;
    this.politicasError = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
  }

  public cambiar() {
    if (this.lectura !== undefined) {
      this.lecturaNumber = parseInt(this.lectura, 10);
      this.lectura = this.lecturaNumber.toString();
    } else {
        this.lecturaNumber = undefined;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/lecturacontador.component.ts